import { CheckCircle, PiggyBank } from '@phosphor-icons/react';
import { Dispatch, SetStateAction } from 'react';
import { SupportIssue } from '../../../@types/Profile.type';

const AnnualPreviewDeclarationResultConfig = ({
	setShowModal,
	supportIssues,
}: {
	setShowModal: Dispatch<
		SetStateAction<{
			positiveBalance: boolean;
			unlinked: boolean;
			paymentInstallments: boolean;
			annualPreferences: boolean;
		}>
	>;
	supportIssues: SupportIssue[];
}) => {
	const positiveBalance = supportIssues.find(
		(issue) => issue.category_type === 'positive_balance_annual_declaration',
	);

	const positiveBalanceConfig = (() => {
		try {
			return JSON.parse(positiveBalance?.message!);
		} catch (error) {
			return null;
		}
	})();

	const allIssuesSet = !!positiveBalance;

	return (
		<div className='bg-white rounded-lg overflow-hidden'>
			<div className='flex flex-col gap-1 p-3'>
				<p className='font-medium flex gap-2 items-center'>
					{!allIssuesSet && <div className='size-2 rounded-full bg-red-600 ' />}
					{!allIssuesSet ? (
						'Tu declaración anual está bloqueada'
					) : (
						<span className='flex gap-2 items-center'>
							<CheckCircle
								weight='fill'
								className='min-w-4 text-h-green-50'
							/>
							Preferencias actualizadas
						</span>
					)}
				</p>
				<p className='text-sm font-light leading-tight'>
					{allIssuesSet
						? 'Utilizaremos las opciones que seleccionaste en el resultado de tu declaración anual.'
						: 'Selecciona a continuación qué quieres hacer en caso de tener saldo a pagar o saldo a favor en el resultado de tu declaración anual.'}
				</p>
			</div>
			<div className='w-full h-1 bg-neutral-100' />
			<div className='p-2 flex flex-col gap-1 hover:bg-neutral-50'>
				<button
					onClick={() =>
						setShowModal((prev) => ({ ...prev, positiveBalance: true }))
					}
					disabled={!!positiveBalance}
					className={`flex w-full text-left gap-2 rounded-lg px-1 pt-2 pb-3  `}
				>
					{positiveBalance ? (
						<CheckCircle
							weight='fill'
							className='mt-1 min-w-4 text-h-green-50'
						/>
					) : (
						<PiggyBank className='mt-1 min-w-4' />
					)}
					<div className='flex flex-col gap-1'>
						<p>
							Saldo a favor:{' '}
							{positiveBalanceConfig
								? positiveBalanceConfig?.typeOfReturn === 'compensation'
									? 'Compensar en próximas declaraciones'
									: `${positiveBalanceConfig?.selectedBank === 'Otro' ? positiveBalanceConfig?.otherBank : positiveBalanceConfig?.selectedBank} (${positiveBalanceConfig?.clabe})`
								: 'Ingresa tus datos bancarios'}
						</p>
						<p className='text-sm font-light leading-tight'>
							En caso de tener saldo a favor, elige si quieres usar tu saldo a
							favor en próximas declaraciones o si prefieres que el SAT te
							devuelva el saldo a tu cuenta bancaria.
						</p>
					</div>
				</button>
			</div>
		</div>
	);
};

export default AnnualPreviewDeclarationResultConfig;
